import Level from "components/common/List/pfLevel";
import DividerLine from "components/common/divider/line";
import {
  usePortfolioDispatch,
  usePortfolioState,
} from "contexts/PortfolioContext";
import Image from "next/image";
import { useRouter } from "next/router";
import { RiArrowDownSFill, RiArrowUpSFill } from "react-icons/ri";
import { TYPO } from "styles/Typo";
import {
  PortfolioTotalPrice,
  PortfolioTotalProfit,
  PortfolioTotalProfitPercent,
} from "utils/portfolio";
import GauageChart from "../components/GauageChart";

export function MainPortfolio({
  portfolios,
  portfolio,
  idx,
  t,
}: {
  portfolios: any;
  portfolio: any;
  idx: number;
  t: any;
}) {
  const router = useRouter();
  const dispatch = usePortfolioDispatch();
  const state = usePortfolioState();
  const baseCurrency = state.baseCurrency;

  const locale = baseCurrency === "USD" ? "en" : "ko";

  const pfRisk = portfolio?.dailyPfRisk;

  return (
    <div key={idx}>
      <div
        onClick={() => {
          router.push(`/portfolio/detail?pf=${portfolio.portName}`);
          dispatch({ type: "SET_PORTFOLIO", payload: portfolio });
        }}
        key={idx}
        className="flex items-center  justify-between gap-3 py-5 cursor-pointer bg-white p-5 rounded-[24px]"
      >
        <div className="flex flex-col gap-2 grow truncate">
          <div className="flex flex-col truncate">
            <h2
              className={`${TYPO.TYPO5_1_MD} text-gray80 truncate`}
              title={portfolio.portName}
            >
              {portfolio.portName}
            </h2>
            <p className={`${TYPO.TYPO8_RG} text-gray40 whitespace-nowrap`}>
              {t("countInvest", {
                count: portfolio.items?.length || 0,
              })}
            </p>
          </div>
          {/* 포폴 총 자산 */}
          <div className="flex flex-col ">
            <p className={`${TYPO.TYPO5_1_SB} text-gray80`}>
              {PortfolioTotalPrice(portfolio, locale)}
            </p>
            {portfolio.totalChange && portfolio.totalChange > 0 ? (
              <div className={`flex items-center ${TYPO.TYPO8_RG} `}>
                <p className={"text-red-500"}>
                  +{PortfolioTotalProfit(portfolio, locale)}{" "}
                  {PortfolioTotalProfitPercent(portfolio)}
                </p>
              </div>
            ) : portfolio.totalChange && portfolio.totalChange <= 0 ? (
              <div className={`flex items-center ${TYPO.TYPO8_RG} `}>
                <p className={"text-blue-500 "}>
                  -{PortfolioTotalProfit(portfolio, locale)}{" "}
                  {PortfolioTotalProfitPercent(portfolio)}
                </p>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="flex items-center space-x-3 shrink-0">
          {portfolio && pfRisk ? (
            <div>
              <GauageChart
                level={pfRisk.CVaR_LV}
                rank={pfRisk.CVaRNTS_PER}
                levelKr={
                  router.locale === "ko" ? pfRisk.CVaR_LV_KR : pfRisk.CVaR_LV
                }
              />
            </div>
          ) : (
            <h1 className={"text-black"}>{""}</h1>
          )}
        </div>
      </div>
      {idx === portfolios.length - 1 ? "" : <DividerLine size="sm" />}
    </div>
  );
}
